<div *ngIf="isOpen" class="fax-zoom-modal-overlay" (click)="close.emit()"></div>

<div *ngIf="isOpen" class="fax-zoom-modal">
  <button class="icon-btn icon-btn_md fax-zoom-modal__close" (click)="close.emit()">
    <img src="assets/img/icons/times.svg" alt="Close preview" />
  </button>

  <div class="fax-zoom-modal__toolbar">
    <button class="fax-zoom-modal__zoom-btn" [disabled]="!canZoomOut" (click)="zoomOut()">−</button>
    <span class="fax-zoom-modal__zoom-level">{{ zoomPercent }}%</span>
    <button class="fax-zoom-modal__zoom-btn" [disabled]="!canZoomIn" (click)="zoomIn()">+</button>
  </div>

  <div class="fax-zoom-modal__content">
    <app-fax-pdf-viewer
      *ngIf="faxFileSrc"
      [faxFileSrc]="faxFileSrc"
      [faxFilePage]="faxFilePage"
      [showControls]="false"
      class="fax-zoom-modal__pdf"
      [style.transform]="'scale(' + zoom + ')'"
    ></app-fax-pdf-viewer>
  </div>
</div>
